import {RectForPicket} from './RectForPicket';
import {Picket} from './Picket';
import {IObject3D} from '../../Interfaces';

declare const THREE: any;

export class IntPicket extends Picket {

  static readonly Name = 'IntPicket';

  private static ipTexture = new THREE.TextureLoader().load('assets/images/scene-plan/ip.png');

  readonly edge: Feeney.IEdge;

  constructor(edge?: Feeney.IEdge) {
    super();
    this.edge = edge ? edge : null;
    this.add(new RectForPicket(10, IntPicket.ipTexture.clone()));
    this.name = IntPicket.Name;
  }

  getRoot(): IObject3D {
    return this.parent;
  }

}


// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Post/IntPicket.ts